import { render } from "./FarmOSGroupTable.vue?vue&type=template&id=efde1114"
import script from "./FarmOSGroupTable.vue?vue&type=script&lang=js"
export * from "./FarmOSGroupTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__